export default "__VITE_ASSET__CrnKKG9D__"